import { ProtectedRoute, TranslationBreadcrumb } from "components/UI";
import { Dashboard } from "./pages";

const dashboardRoutes = [
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute name="dashboard" isDefaultPath>
        <Dashboard />
      </ProtectedRoute>
    ),
    breadcrumb: () => <TranslationBreadcrumb name="dashboard" />,
  },
];

export default dashboardRoutes;
